import { createContext, useCallback, useContext, useState, type ReactNode } from "react";
import { WifiSpeedTestDialog } from "@/components/WifiSpeedTestDialog";

type Source = "detail" | "checkin_confirm" | "push" | "other";

interface OpenArgs {
  cafeId: string;
  cafeName: string;
  checkInId?: string | null;
  source?: Source;
}

interface WifiSpeedTestContextValue {
  openWifiTest: (args: OpenArgs) => void;
}

const WifiSpeedTestContext = createContext<WifiSpeedTestContextValue | null>(null);

export function WifiSpeedTestProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const [args, setArgs] = useState<OpenArgs | null>(null);

  const openWifiTest = useCallback((next: OpenArgs) => {
    setArgs(next);
    setOpen(true);
  }, []);

  return (
    <WifiSpeedTestContext.Provider value={{ openWifiTest }}>
      {children}
      {args && (
        <WifiSpeedTestDialog
          open={open}
          onOpenChange={(o) => {
            setOpen(o);
            if (!o) setArgs(null);
          }}
          cafeId={args.cafeId}
          cafeName={args.cafeName}
          checkInId={args.checkInId ?? null}
          source={args.source ?? "other"}
        />
      )}
    </WifiSpeedTestContext.Provider>
  );
}

export function useWifiSpeedTest() {
  const ctx = useContext(WifiSpeedTestContext);
  if (!ctx) throw new Error("useWifiSpeedTest must be used inside WifiSpeedTestProvider");
  return ctx;
}
